@if (showBanner) {
  <div class="ue-finance-banner">
    <img
      class="ue-finance-banner__img"
      src="assets/img/UE-MALOPOLSKA-projekt__horizontal.png"
      alt="Project co-financed by the European Union and the Małopolska Region" />
  </div>
}
